import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect } from 'react';
export const defaultRouter = {
    Link: ({ children, ...props }) => _jsx("a", { ...props, children: children }, void 0),
    Redirect: ({ to }) => {
        useEffect(() => {
            window.history.pushState({}, '', to);
        }, []);
        return null;
    },
    redirect: href => {
        window.location.href = href;
    },
    push: path => {
        window.history.pushState({}, '', path);
    },
    replace: path => {
        window.history.replaceState({}, '', path);
    },
    params: {},
    location: typeof window === 'object'
        ? window.location
        : { pathname: '/', search: '' },
};
export const RouterContext = createContext(defaultRouter);
export const useRouter = () => {
    return useContext(RouterContext);
};
RouterContext.displayName = 'TribeRouter';
export const TribeRouter = ({ children, ...rest }) => {
    return (_jsx(RouterContext.Provider, { value: rest || defaultRouter, children: children }, void 0));
};
//# sourceMappingURL=RouterProvider.js.map